import React, { useState } from "react";
import Carousel from "@itseasy21/react-elastic-carousel";
import CloseIcon from '@mui/icons-material/Close';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EtsyIcon from '@mui/icons-material/Storefront';

import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box, Modal, Button
} from "@mui/material";
import './Components.scss';

const VendorCard = ({ name, headVendor, description, logo, socials, images = [] }) => {
  console.log("logo", logo)
  console.log("images..", images)
  console.log("socials", socials)
  const [open, setOpen] = useState(false);
  let socialLinks = []
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <div>
        <Card
          onClick={() => setOpen(true)}
          sx={{
            borderRadius: 3,
            boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
            transition: "0.3s",
            height: 350,  // Fixed height
            // width: "100%", // Allow it to grow on smaller screens
            width: 270, // Fixed width on larger screens
            overflow: 'hidden',
            display: "flex",
            flexDirection: "column",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.18)",
              transform: "translateY(-3px)",
            },
          }}
        >
          {/* Featured Image */}
          <CardMedia
            component="img"
            image={logo}
            alt={name}
            sx={{
              height: 220,
              width: "100%",
              objectFit: "cover",
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            }}
          />

          <CardContent sx={{ flexGrow: 1 }}>
            {/* Vendor Name */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {name}
            </Typography>
            {/* Social links */}
            <div>
              {socials && socials.length > 0 && socials.map((social, index) => {
                const icons = [];

                // Check if 'fb' property exists and add FacebookIcon to array
                if (social.hasOwnProperty("fb")) {
                  icons.push(
                    <a key={`fb-${index}`} href={social.fb} target="_blank" rel="noopener noreferrer">
                      <FacebookIcon key={`fb-${index}`} style={{ cursor: "pointer", fontSize: 20, color: '#1877F2' }} />
                    </a>);
                }

                // Check if 'ig' property exists and add InstagramIcon to array
                if (social.hasOwnProperty("ig")) {
                  icons.push(
                    <a key={`${index}`} href={social.ig} target="_blank" rel="noopener noreferrer">
                      <InstagramIcon key={`ig-${index}`} style={{ cursor: "pointer", fontSize: 20, color: '#E1306C' }} />
                    </a>);
                }

                // Check if 'wp' property exists and add WhatsappIcon to array
                if (social.hasOwnProperty("wp")) {
                  icons.push(
                    <a key={`wp-${index}`} href={social.wp} target="_blank" rel="noopener noreferrer">
                      <WhatsAppIcon key={`wp-${index}`} style={{ cursor: "pointer", fontSize: 20, color: '#25D366' }} />
                    </a>);
                }

                // Check if 'wp' property exists and add WhatsappIcon to array
                if (social.hasOwnProperty("et")) {
                  icons.push(
                    <a key={`et-${index}`} href={social.et} target="_blank" rel="noopener noreferrer">
                      <EtsyIcon key={`et-${index}`} style={{ cursor: "pointer", fontSize: 20, color: '#F4A261' }} />
                    </a>);
                }

                socialLinks = icons
                // setSocialLinks(icons)
                // If we have icons, render them
                return icons.length > 0 ? <div key={index}>{icons}</div> : null;
              })}

            </div>
            {/* Head Vendor */}
            {headVendor && (
              <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, }}>
                <strong>Head Vendor:</strong> {headVendor}
              </Typography>
            )}
            {/* Description */}
            {description && (
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 2,
                fontSize: 12,
                display: "-webkit-box",
                WebkitLineClamp: 3,     // show up to 4 lines
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}>
                {description}
              </Typography>
            )}
          </CardContent>
        </Card>
      </div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "80%", md: "70%", lg: "60%" }, // Responsive width based on screen size
            maxWidth: 700, // Max width for the modal
            bgcolor: "white",
            borderRadius: 2,
            boxShadow: 24,
            padding: 2, // Adding padding for spacing
          }}
        >
          {/* Modal Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h1 style={{ textAlign: "center", margin: 0 }}>{name}</h1>
            <CloseIcon style={{ cursor: "pointer", fontSize: 18 }} onClick={handleClose} />
          </div>
          {/* Contacts Links */}
          {socialLinks && socialLinks.length > 0 ? <div>{socialLinks}</div> : null}
          {/* Description */}
          <p style={{ textAlign: "left", marginTop: 2, fontSize: 14 }}>
            {description}
          </p>

          {/* Carousel for Images */}
          <div style={{ width: "100%", margin: "auto" }}>
            <Carousel breakPoints={breakPoints}
              sx={{
                '& .control-dots .dot': {
                  backgroundColor: 'transparent',  // Remove default background color
                  border: '2px solid #000', // Border color for inactive dots
                },
                '& .control-dots .dot.selected': {
                  backgroundColor: 'transparent', // Remove purple from active dot
                  border: '2px solid pink', // Set border color for active dot (e.g., blue)
                }
              }}>
              {images.map((image, idx) => (
                <div className="item" key={idx} style={{ marginTop: 8 }}>
                  <img
                    src={image}
                    alt="sliderImg"
                    style={{
                      width: "100%",
                      height: 250,
                      objectFit: "cover", // Ensures the image covers the space
                      borderRadius: "10px", // Adds rounded corners for the images
                    }}
                  />
                </div>
              ))}
              {/* <div className="item">
                <img
                  src={fashion_bazaar_2025}
                  alt="sliderImg"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover", // Ensures the image covers the space
                    borderRadius: "10px", // Adds rounded corners for the images
                  }}
                />
              </div>
              <div className="item">Item 2</div>
              <div className="item">Item 3</div>
              <div className="item">Item 4</div>
              <div className="item">Item 5</div> */}
            </Carousel>
          </div>
        </Box>
      </Modal>

    </>
  );
};

export default VendorCard;

